'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility service to use à global $uiLoader.Loader instance on the document.body element.
 */
ngModule.factory("$uiBlock", function ($rootScope, $compile) {
  var loaderLinkFn = $compile("<div class='tl-loader-overlay'>" + "   <tl-circular-loader></tl-circular-loader>" + "</div>");
  var globalLoader = null;
  var getLoaderElement = function getLoaderElement($scope) {
    var loader = null;
    loaderLinkFn($scope, function (clone) {
      loader = clone;
    });
    return loader;
  };
  var Loader = function Loader($el, $scope) {
    var loader = this,
      loaderEl = getLoaderElement($scope);
    loader.show = function () {
      loaderEl.appendTo($el).show();
    };
    loader.hide = function () {
      loaderEl.fadeOut(200);
    };
    loader.destroy = function () {
      loaderEl.remove();
    };
    $scope.$on("$destroy", function () {
      loader.destroy();
    });
  };
  return {
    block: function block() {
      if (globalLoader == null) {
        globalLoader = new Loader(document.body, $rootScope, {});
      }
      globalLoader.show();
    },
    unblock: function unblock() {
      if (globalLoader != null) {
        globalLoader.hide();
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/$uiBlock.js
// module id = 2913
// module chunks = 13